
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 39a4.196 4.196 0 002.497-.825A4.457 4.457 0 0028.07 36h-8.14a4.457 4.457 0 001.573 2.175c.73.538 1.602.826 2.497.825zm10.111-11.121V21c0-4.826-3.156-8.89-7.432-10.113C26.256 9.78 25.222 9 24 9c-1.222 0-2.256.78-2.68 1.887C17.045 12.11 13.89 16.174 13.89 21v6.879l-2.466 2.56A1.53 1.53 0 0011 31.5V33c0 .398.152.78.423 1.06.271.282.638.44 1.021.44h23.112c.383 0 .75-.158 1.02-.44A1.53 1.53 0 0037 33v-1.5c0-.398-.152-.78-.423-1.06l-2.466-2.561z","fill":"#5D5D5D"}})])
          )
        }
      }
    